import React from "react";
import { Navigate } from "react-router-dom";

// Issue 37: this page used to duplicate ManageSubscription.jsx's plan picker,
// but called SubscriptionService.createCheckoutSession() without a
// restaurant_uuid - the backend now requires one to resolve which
// restaurant/organization the subscription belongs to (subscriptions are
// restaurant/organization-scoped, not user-scoped). Rather than maintain two
// separate checkout flows that could drift out of sync on restaurant
// selection and billing-authority checks, this now redirects to the
// Subscription page, which already handles restaurant selection, viewing,
// and (for eligible users) starting the first subscription.
const Plans = () => <Navigate to="/subscription" replace />;

export default Plans;
